<template>
  <div class="mb-5">
    <!-- Breadcrumb -->
    <div class="container">
      <div class="section breadcrumb">
        <div class="header-wrapper">
          <b-breadcrumb align="is-left">
            <b-breadcrumb-item tag='router-link' to="/happenings">Happenings</b-breadcrumb-item>
            <b-breadcrumb-item tag='router-link' to="/happenings/training" active>Trainings</b-breadcrumb-item>
          </b-breadcrumb>
          <div class="pb-title">TRAININGS</div>
        </div>
      </div>
    </div>
    <!-- Content -->
    <div class="container">
      <div class="section pt-0 pb-6">
        <!-- Month Filter -->
        <div class="columns mr-0 is-12 is-desktop is-mobile is-multiline">
          <div class="column is-2-desktop is-3-tablet is-12-mobile pr-0">
            <b-field class="bg-white">
              <b-select placeholder="Select month" v-model="inputMonth">
                <option style="color: #363636 !important" value="" selected>Select Month</option>
                <option v-for="item, index in monthOptions" :value="item.value" :key="index">

                  {{ item.label }}
                </option>
              </b-select>
            </b-field>
          </div>
          <!-- Year Filter -->
          <div class="column is-2-desktop is-3-tablet is-12-mobile pr-0">
            <b-field class="bg-white">
              <b-select placeholder="Select year" v-model="inputYear">
                <option style="color: #363636 !important" value="" selected>Select Year</option>
                <option v-for="year, index in years" :value="year" :key="index">

                  {{ year }}
                </option>
              </b-select>
            </b-field>
          </div>
          <!-- Rankings Filter -->
          <div class="column is-4-desktop is-6-tablet is-12-mobile pr-0" v-if="this.ranking !== 'WA'">
            <b-field class="bg-white">
              <b-select placeholder="Select Ranking" v-model="inputRanking">
                <option style="color: #363636 !important" value="" selected>Select Rankings</option>
                <option v-for="ranking, index in filteredRankings" :value="ranking" :key="index">

                  {{ capitalized(ranking) }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-hidden-touch"></div>
        </div>
      </div>
    </div>

    <!-- Month tab-->
    <div class="container">

      <!-- wanie code -->
      <div class="section py-1" v-for="item, index in getFilteredTrainingData" :key="index">
        <div class="is-flex is-justify-content-space-between">
          <div class="month-tab bold-l2">
            {{ (item[0].month).toUpperCase() }} {{ item[0].year }}
          </div>
          <div v-show="Object.keys(getFilteredTrainingData)[0] == index">
            <div class="is-hidden-touch">
              <b-icon icon="view-grid-outline" custom-size="mdi-24px" class="pr-4 is-clickable"
                @click.native="layout = 'grid'" :style="{ color: layout === 'grid' ? '#FDB913' : '#C4C4C4' }">
              </b-icon>
              <b-icon icon="sort-variant" class="is-clickable" custom-size="mdi-24px" @click.native="layout = 'list'"
                :style="{ color: layout === 'list' ? '#FDB913' : '#C4C4C4' }">
              </b-icon>
            </div>
          </div>
        </div>
        <hr style="background-color: #2B2D47">

        <!-- Grid -->
        <div v-show="layout === 'grid' || (layout === 'list' && isTouchView)">
          <div class="columns is-mobile is-tablet is-desktop is-multiline campaigns-columns has-text-left">
            <template v-for="data, k in item.slice(0, item[0].trainingSize)">
              <div class="column is-6-mobile is-4-tablet is-4-desktop">
                <div class="desc-box details-container">
                  <router-link class="course-details"
                    :to="{ name: 'course-summary', query: { courseId: data.data.uuid } }">
                    <div class="grid-image ">
                      <figure class="image is-square">
                        <img
                          :src="data.data.image.data ? data.data.image.data.attributes.url : require('@/assets/img/default_photo.png')">
                      </figure>
                    </div>
                    <div class="desc-wrapper">
                      <div class="ellipsis-title grid-event-title pb-title">{{ data.data.title ? data.data.title : '' }}
                      </div>
                      <div class="desc-textbox">
                        <div>Date: {{ data.data.date ? formatDate(data.data.date) : '' }}</div>
                        <div>Time: {{ data.data.start && data.data.end ? formatTime(data.data.start, data.data.end) : ''
                        }}</div>
                        <div>Registration opening: {{ data.data.registration_start && data.data.registration_end ?
                          formatDateRange(data.data.registration_start, data.data.registration_end) : '' }}</div>
                        <div>CPD Points: {{ data.data.cpdPoint && data.data.cpdPoint != 0 ? data.data.cpdPoint : 'N/A' }}
                        </div>
                        <div class="open-to-title">{{ 'Open to ' + (data.data.targetUser == 'Managing Partner' ? 'Managing
                                                  Partner only' : data.data.targetUser == 'Public' || data.data.targetUser == 'For consultants
                                                  only' || data.data.targetUser == 'all consultants' ? 'all consultants' : data.data.targetUser ?
                        data.data.targetUser + ' and higher only' : 'all consultants') }}</div>
                      </div>
                    </div>
                  </router-link>
                  <div>
                    <div v-if="isEnrollUuidMatching(data.data.uuid)" class="registration-approved is-align-items-center"
                      style="display:flex;margin-bottom:10px;padding-top:10px;white-space: nowrap;">
                      <div style="margin-left:0px;margin-top:8px;">
                        <img src="@/assets/icons/Approved.svg" style="height:24px;width:24px;">
                      </div>
                      <div class="registration-text">
                        Registered
                      </div>
                    </div>
                    <b-button v-else-if="!isEnrollUuidMatching(data.data.uuid) && dateExpired(data.data.date)" type=""
                      class="button dark-red join-now-btn"
                      :disabled="periodRange(data.data.registration_start, data.data.registration_end) ? true : false"
                      @click="viewDetails(data.data.date, data.data.uuid)">
                      <div>Join Now <b-icon class="ml-1" icon="play" size="is-small"></b-icon></div>
                    </b-button>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <!-- VIEW ALL BUTTON -->
          <div v-if="item.length > 3 && item[0].hideButton"
            style="margin: 2rem 0; position: relative; width: 100%; align-items: center;">
            <a class="text-link" @click="loadData(index)" style="position: inherit; color: #730039 !important;">
              View All
            </a>
          </div>
          <div v-else class="mb-6"></div>
        </div>

        <!-- List -->
        <div v-show="layout === 'list' && !isTouchView">
          <div class="data-list-wrapper">
            <template v-for="data, k in item.slice(0, item[0].trainingSize)">
              <div class="columns">
                <div class="column is-3 details-container">
                  <router-link :to="{ name: 'course-summary', query: { courseId: data.data.uuid } }">
                    <div class="image-wrapper">
                      <figure class="image is-square">
                        <img style="object-fit: cover;min-height:175px"
                          :src="data.data.image.data ? data.data.image.data.attributes.url : require('@/assets/img/default_photo.png')">
                      </figure>
                    </div>
                  </router-link>
                </div>
                <div class="column is-7 has-text-left py-1 px-4">
                  <router-link class="course-details"
                    :to="{ name: 'course-summary', query: { courseId: data.data.uuid } }">
                    <div class="ellipsis-title-list list-event-title pb-title">{{ data.data.title ? data.data.title : ''
                    }}</div>
                    <div>Date: {{ data.data.date ? formatDate(data.data.date) : '' }}</div>
                    <div>Time: {{ data.data.start && data.data.end ? formatTime(data.data.start, data.data.end) : '' }}
                    </div>
                    <div>Registration opening: {{ data.data.registration_start && data.data.registration_end ?
                      formatDateRange(data.data.registration_start, data.data.registration_end) : '' }}</div>
                    <div>CPD Points: {{ data.data.cpdPoint && data.data.cpdPoint != 0 ? data.data.cpdPoint : 'N/A' }}
                    </div>
                    <div class="open-to-title">{{ 'Open to ' + (data.data.targetUser == 'Managing Partner' ? 'Managing
                                          Partner only' : data.data.targetUser == 'Public' || data.data.targetUser == 'For consultants only'
                      || data.data.targetUser == 'all consultants' ? 'all consultants' : data.data.targetUser ?
                      data.data.targetUser + ' and higher only' : 'all consultants') }}</div>
                  </router-link>
                </div>
                <div class="column is-2 join-now-btn">
                  <div v-if="isEnrollUuidMatching(data.data.uuid)"
                    class="registration-approved-list is-align-items-center join-now-btn">
                    <div style="margin-left:0px;margin-top:8px;">
                      <img src="@/assets/icons/Approved.svg" style="height:24px;width:24px;">
                    </div>
                    <div class="registration-text">
                      Registered
                    </div>
                  </div>
                  <b-button v-else-if="!isEnrollUuidMatching(data.data.uuid) && dateExpired(data.data.date)" type=""
                    class="button dark-red join-now-btn"
                    :disabled="periodRange(data.data.registration_start, data.data.registration_end) ? true : false"
                    @click="viewDetails(data.data.date, data.data.uuid)">
                    <div>Join Now <b-icon class="ml-1" icon="play" size="is-small"></b-icon></div>
                  </b-button>

                </div>
              </div>
            </template>
          </div>
          <!-- VIEW ALL BUTTON -->
          <div v-if="item.length > 3 && item[0].hideButton"
            style="margin-top: 1.5rem; position: relative; width: 93%; align-items: center;">
            <a class="text-link" @click="loadData(index)" style="position: inherit; color: #730039 !important;">
              View All
            </a>
          </div>
        </div>
      </div>

    </div>

    <div v-if="Object.keys(getFilteredTrainingData).length == 0 && (inputMonth || inputYear || inputRanking)"
      style="min-height: 100px; margin-inline: auto;">
      No results of trainings found.
    </div>

    <div
      v-else-if="Object.keys(getFilteredTrainingData).length == 0 && (inputMonth === '' && inputYear === '' && inputRanking === '')"
      style="min-height: 100px; margin-inline: auto;">
      No results of upcoming trainings found.
    </div>

    <div class="is-flex is-justify-content-end">
      <ScrollTop />
    </div>

    <!-- Modal (hidden) -->
    <b-modal v-model="isModalActive" :can-cancel="false" style="padding: 0 1rem;">
      <div class="modal-card" style="margin: auto;">
        <header class="modal-card-head pt-2 pb-2 pl-2 pr-2 modal-header"
          style="background: #730039; border-radius: 0px; height: 50px;">
          <p class="modal-card-title"></p>
          <b-button class="close-btn" style="background: transparent !important;" @click="isModalActive = false"><b-icon
              icon="close" style="color:#FFFFFF; cursor: pointer; height: 100%"></b-icon></b-button>
        </header>

        <div class="modal-card-body pl-5 pr-5 pt-5 pb-5">
          <div class="has-text-centered">
            <div class="pop-up-text">
              <div class="pl-4 pr-4" style="color: #363636;">This training is only available for AHAM Wealth Partners
                registered consultants. To register, please <span @click="login"
                  style="color: #3DBB95 !important; text-decoration: underline !important; cursor: pointer;">login
                  here</span> or <span @click="$router.push('/contact-us')"
                  style="color: #3DBB95 !important; text-decoration: underline !important; cursor: pointer;">get in touch
                  with us</span> to understand more.</div>
              <hr class="divider">
              <div class="">
                <div class="wrapper-contact">
                  <div>
                    <a href="tel:+1-800-22-2288" class="is-flex is-align-items-center">
                      <img class="mr-2 has-text-left" src="@/assets/icons/pop-up-call.svg" />
                      <span class="colour-text">Tel: 1800-22-2288</span>
                    </a>
                  </div>
                  <div>
                    <a href="mailto:parasupport@aham.com.my" class="is-flex is-align-items-center">
                      <img class="mr-2 has-text-left" src="@/assets/icons/email.png" />
                      <a href="mailto:parasupport@aham.com.my" target="_self"
                        class="colour-text">parasupport@aham.com.my</a>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- modal (hidden)-->
    <b-modal v-model="isConfirm" style="padding: 0 1rem;">
      <div class="modal-card" style="margin: auto;">
        <header class="modal-card-head pt-2 pb-2 pl-2 pr-2 modal-header"
          style="background: #730039; border-radius: 0px; height: 50px;">
          <p class="modal-card-title"></p>
          <b-button class="close-btn" style="background: transparent !important;" @click="isConfirm = false"><b-icon
              icon="close" style="color:#FFFFFF; cursor: pointer; height: 100%"></b-icon></b-button>
        </header>

        <div class="modal-card-body pl-5 pr-5 pt-5 pb-5">
          <div class="has-text-centered">
            <div class="pop-up-text">
              <p class="pl-5 pr-5" style="color: #363636;">Would you like to secure your spot for this training?</p>
              <br>
              <div class="">
                <b-button class="pl-6 pr-6 mr-5" style="color:#730039;border:1px solid #730039;background-color: white;"
                  @click="isConfirm = false">No</b-button>
                <b-button class="button dark-red pl-6 pr-6" @click="register(modalDate, modalUuid)">Yes</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Modal (hidden) -->
    <b-modal v-model="registerSuccess" style="padding: 0 1rem;">
      <div class="modal-card" style="margin: auto;">
        <header class="modal-card-head pt-2 pb-2 pl-2 pr-2 modal-header"
          style="background: #730039; border-radius: 0px; height: 50px;">
          <p class="modal-card-title"></p>
          <b-button class="close-btn" style="background: transparent !important;" @click="refreshData()"><b-icon
              icon="close" style="color:#FFFFFF; cursor: pointer; height: 100%"></b-icon></b-button>
        </header>

        <div class="modal-card-body pl-5 pr-5 pt-5 pb-5">
          <div class="has-text-centered">
            <div class="pop-up-text">
              <p class="pl-5 pr-5" style="color: #363636;">You have successfully registered for the training.</p>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-loading :is-full-page="true" v-model="isLoading">
      <b-icon pack="mdi" icon="loading" size="is-large" custom-class="mdi-spin">
      </b-icon>
    </b-loading>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import SearchBar from "../../components/SearchBar.vue";
import ScrollTop from '../../components/ScrollTop.vue';


export default {
  components: { SearchBar, ScrollTop },
  data() {
    return {
      isTouchView: false,
      dataLength: 0,
      isModalActive: false,
      trainings: [],
      contentList: [],
      topData: [],
      counter: 0,
      layout: 'list', //default is list
      // Filter props
      inputMonth: '',
      inputYear: '',
      inputRanking: '',
      monthOptions: [
        {
          label: 'January',
          value: '1'
        },
        {
          label: 'February',
          value: '2'
        },
        {
          label: 'March',
          value: '3'
        },
        {
          label: 'April',
          value: '4'
        },
        {
          label: 'May',
          value: '5'
        },
        {
          label: 'June',
          value: '6'
        },
        {
          label: 'July',
          value: '7'
        },
        {
          label: 'August',
          value: '8'
        },
        {
          label: 'September',
          value: '9'
        },
        {
          label: 'October',
          value: '10'
        },
        {
          label: 'November',
          value: '11'
        },
        {
          label: 'December',
          value: '12'
        },
      ],
      shortMonths: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ],
      fullMonths: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ],
      years: [],
      ranking: null,
      rankings: ["all consultants", "Wealth Associate", "Wealth Manager", "Senior Wealth Partner", "Managing Partner"],
      paramRank: '',

      isConfirm: false,
      modalDate: '',
      modalUuid: '',
      registerSuccess: false,
      isLoading: false,
      url1: '',
      url2: '',
      enrollList: [],
      showAll: false
    }
  },
  mounted() {

    this.ranking = this.$store.state.user.ranking;

    if (this.isAuthenticated) {
      let targetUserFilter = '';

      if (this.ranking === 'WA') {
        targetUserFilter = '&filters[targetUser][$eq]=Public&filters[targetUser][$eq]=Wealth Associate';
      } else if (this.ranking === 'WM') {
        targetUserFilter = '&filters[targetUser][$eq]=Public&filters[targetUser][$eq]=Wealth Manager&filters[targetUser][$eq]=Wealth Associate';
      } else if (this.ranking === 'SWP') {
        targetUserFilter = '&filters[targetUser][$eq]=Public&filters[targetUser][$eq]=Senior Wealth Partner&filters[targetUser][$eq]=Wealth Manager&filters[targetUser][$eq]=Wealth Associate';
      }

      this.url1 = `api/trainings?populate=*${targetUserFilter}&sort=date:asc&pagination[limit]=-1&filters[date][$gte]=${dayjs(new Date()).format('YYYY-MM-DD')}`;
      this.url2 = `api/trainings?populate=*${targetUserFilter}&sort=date:asc&pagination[limit]=-1`;
    }
    this.getEnrollList();

    //default for mobile & tablet == grid
    if (window.innerWidth < 1024) {
      this.$set(this, "layout", 'grid')
    }

    // this.generateYears()

    // set trainings first load (more than current month)
    this.$httpClientCMS({
      method: 'GET',
      url: this.url1
    })
      .then(resp => {
        let data = resp.data.data
        for (let x = 0; data.length > x; x++) {

          //split day,month,year for populate
          let split = (data[x].attributes.date).split('-')
          let newData = {
            month: this.fullMonths[parseInt(split[1]) - 1],
            monthNum: parseInt(split[1]),
            year: split[0],
            trainingSize: 3,
            data: data[x].attributes,
            hideButton: true
          }

          this.topData.push(newData)
        }

        //grouped by month
        let sliced = this.groupBy(this.topData, 'monthNum')

        //take only first two objects
        if (Object.keys(sliced).length > 2) {
          this.trainings = Object.assign({}, ...Object.entries(sliced).slice(0, 2)
            .map(([key, prop]) => ({ [key]: prop })));
        } else {
          this.trainings = sliced
        }
      })

    // prepare content for the search component
    this.$httpClientCMS({
      method: 'GET',
      url: this.url2
    })
      .then(resp => {

        let data = resp.data.data
        var popData = []
        for (let x = 0; data.length > x; x++) {

          //split day,month,year for populate
          let split = (data[x].attributes.date).split('-')
          let newData = {
            month: this.fullMonths[parseInt(split[1]) - 1],
            numMonth: parseInt(split[1]),
            monthYear: parseInt(split[1]) + "-" + split[0],
            year: split[0],
            trainingSize: 3,
            data: data[x].attributes,
            hideButton: true
          }
          popData.push(newData)
        }

        //list all year in data.attributes.date
        let yearList = data.map(i => i.attributes.date.split('-')[0])
        //remove duplicate year
        let uniqueYear = [...new Set(yearList)]
        //sort year
        let sortedYear = uniqueYear.sort((a, b) => b - a)
        //set year
        this.$set(this, "years", sortedYear);

        //grouped by month
        let sliced = this.groupBy(popData, 'monthYear')
        this.$set(this, "contentList", sliced);

      })
      .catch((error) => {
        this.$router.push('maintenance');
      });

  },
  methods: {
    refreshData() {
      this.registerSuccess = false
      this.getEnrollList()
    },
    toggleShowAll() {
      this.showAll = !this.showAll;
    },
    periodRange(startDate, endDate) {
      let today = new Date()
      let nStartDate = new Date(startDate)
      let nEndDate = new Date(endDate)
      nEndDate.setDate(nEndDate.getDate() + 1)

      //if today is between start and end date
      if (today.getTime() >= nStartDate.getTime() && today.getTime() <= nEndDate.getTime()) {
        return false
      }
      else {
        return true
      }
    },
    formatDateRange(startDate, endDate) {
      // Convert the date strings to Date objects
      startDate = new Date(startDate);
      endDate = new Date(endDate);

      // Format the start and end dates
      const startFormatted = `${startDate.getDate()} ${this.shortMonths[startDate.getMonth()]} ${startDate.getFullYear()}`;
      const endFormatted = `${endDate.getDate()} ${this.shortMonths[endDate.getMonth()]} ${endDate.getFullYear()}`;

      // Check if the dates are in different months or years
      if (startDate.getFullYear() !== endDate.getFullYear()) {
        return `${startFormatted} - ${endFormatted}`;
      }
      else if (startDate.getMonth() !== endDate.getMonth() && startDate.getFullYear() == endDate.getFullYear()) {
        return `${startDate.getDate()} ${this.shortMonths[startDate.getMonth()]} - ${endDate.getDate()} ${this.shortMonths[endDate.getMonth()]} ${endDate.getFullYear()}`;
      }
      else {
        return `${startDate.getDate()} - ${endDate.getDate()} ${this.shortMonths[startDate.getMonth()]} ${startDate.getFullYear()}`;
      }
    },
    getEnrollList() {
      const loadingComponent = this.$buefy.loading.open();
      let today = dayjs();
      let startDate = today.format('YYYY-MM-DD');
      this.$httpClient({
        method: "GET",
        url: "/pbmicrosite/enroll/" + this.$store.state.user.uuid + "?startdate=" + startDate,
      }).then((resp) => {
        this.$set(this, "enrollList", resp.data);
        loadingComponent.close()
      });
    },
    isEnrollUuidMatching(eventUuid) {
      // Iterate through enrollList to check if eventUuid matches any enroll.CourseId
      for (const enroll of this.enrollList) {
        if (eventUuid === enroll.CourseId) {
          return true; // Matching UUID found, so return true
        }
      }
      return false; // No matching UUID found, so return false
    },
    capitalized(name) {
      return name.toLowerCase().replace(/(^|\s|-|\')(\w)/g, function (match) {
        return match.toUpperCase();
      });
    },
    updateMobileView() {
      this.isTouchView = window.innerWidth < 1023;
    },
    register(date, courseId) {
      this.isConfirm = false;
      this.isLoading = true
      //if consultant
      if (this.isAuthenticated) {
        this.fullname = this.$store.state.user.name
        this.email = this.$store.state.user.email
        // POST to endpoint (consultant)
        let month = dayjs(date).month() + 1;
        let year = dayjs(date).year();
        let startDate = year + '-' + month + '-01';
        let end = dayjs(startDate).daysInMonth();     // number of days in a month (28-31)
        let endDate = year + '-' + month + '-' + end;
        this.$httpClient({
          method: "GET",
          url: "/pbmicrosite/enroll/" + this.$store.state.user.uuid + "?startdate=" + startDate + "&enddate=" + endDate,
        }).then((resp) => {
          let enroll = resp.data.filter(i => i.CourseId === courseId.toString());
          if (enroll.length > 0) {
            this.$buefy.toast.open({
              message: 'This course is registered',
              type: 'is-danger'
            })
            this.registerSuccess = false;
            this.isLoading = false
          } else {
            // POST to endpoint
            this.$httpClient.post("/pbmicrosite/register/" + courseId,
              {
                ParticipantId: this.$store.state.user.uuid.toString(),
                ParticipantType: 1,
                Fullname: this.fullname.toString(),
                Email: this.email.toString()
              })
              .then(resp => {
                if (resp.data.EnrollStatus === true) {
                  // this.$buefy.toast.open({
                  //   message: 'You have successfully registered into the course',
                  //   type: 'is-success'
                  // })

                  //popup modal success
                  this.registerSuccess = true;
                  this.isLoading = false
                }
              })
              .catch((error) => {
                this.$buefy.toast.open({
                  message: 'This course is full, registration denied',
                  type: 'is-danger'
                })
                this.registerSuccess = false;
                this.isLoading = false
              });
          }
        });
      }
      //if public
      else {
        // POST to endpoint (public)
        this.$httpClient.post("/internal/pbmicrosite/register/" + courseId,
          {
            ParticipantType: 0,
            PbNric: this.nric.toString(),
            PbFirstname: this.firstname.toString(),
            PbLastname: this.lastname.toString(),
            PbFullname: this.fullname.toString(),
            PbEmail: this.email.toString(),
            PbPhoneno: this.phone.toString()
          })
          .then(resp => {
            if (resp.data.EnrollStatus === true) {
              this.$buefy.toast.open({
                message: 'You have successfully registered into the course',
                type: 'is-success'
              })
              location.reload();
            }
          })
          .catch((error) => {
            this.$buefy.toast.open({
              message: 'This course is full, registration denied',
              type: 'is-danger'
            });
            this.registerSuccess = false;
            this.modalActive = false;
          });
      }
    },
    login() {
      this.$store.dispatch('auth/login');
    },
    dateExpired(apiDate) {
      let today = new Date()
      let dataDate = new Date(apiDate)

      if (dataDate.getTime() < today.getTime()) {
        return false
      }
      else {
        return true
      }
    },
    groupBy(objectArray, property) {
      return objectArray
        .reduce((acc, obj) => {
          const key = obj[property];
          const curGroup = acc[key] ?? [];

          return { ...acc, [key]: [...curGroup, obj] };
        }, {});
    },
    loadData(k) {
      if (this.inputMonth || this.inputYear || this.inputRanking) {
        this.getFilteredTrainingData[k][0].trainingSize = this.getFilteredTrainingData[k].length
        this.getFilteredTrainingData[k][0].hideButton = false
      }
      else {
        this.trainings[k][0].trainingSize = this.trainings[k].length
        this.trainings[k][0].hideButton = false
      }
    },
    viewDetails(dataDate, dataUuid) {
      if (this.isAuthenticated) {
        // localStorage.setItem("trainingDate", trainingDate);
        // localStorage.setItem("viewTraining", 'true');
        // return this.$router.push({ name: 'consultant-training' })
        this.isConfirm = true;
        this.modalUuid = dataUuid;
        this.modalDate = dataDate;
      } else {
        this.isModalActive = true;
      }
    },
    formatDate(monthYear) {
      const tempDate = new Date(monthYear);

      let formattedDate = tempDate.getDate() + " " + this.fullMonths[tempDate.getMonth()] + " " + tempDate.getFullYear();
      return formattedDate;
    },
    formatTime(start, end) {
      //start time
      const tempDate1 = new Date();
      tempDate1.setHours(start.slice(0, 2));
      tempDate1.setMinutes(start.slice(3, 5));

      let startAmpm = (tempDate1.getHours() < 12) ? "AM" : "PM"
      let startHour = tempDate1.getHours() % 12;
      let startMinute = tempDate1.getMinutes();

      if (startHour == 0) {
        startHour = 12;
      }
      // startHour = ("0" + startHour).slice(-2);
      startMinute = ("0" + startMinute).slice(-2);

      //end time
      const tempDate2 = new Date();
      tempDate2.setHours(end.slice(0, 2));
      tempDate2.setMinutes(end.slice(3, 5));

      let endAmpm = (tempDate2.getHours() < 12) ? "AM" : "PM"
      let endHour = tempDate2.getHours() % 12;
      let endMinute = tempDate2.getMinutes();

      if (endHour == 0) {
        endHour = 12;
      }
      // endHour = ("0" + endHour).slice(-2);
      endMinute = ("0" + endMinute).slice(-2);

      let formattedDate = startHour + ":" + startMinute + startAmpm + " - " +
        endHour + ":" + endMinute + endAmpm;
      return formattedDate;
    },
    generateYears() {
      var today = dayjs();
      let currentYear = parseInt(dayjs(today).format('YYYY'));  // set default dropdown year
      for (let i = 0; i < 3; i++) {
        this.years[i] = (currentYear - i).toString();
      }
    },
  },
  computed: {
    filteredRankings() {
      if (this.ranking === 'MP') {
        return this.rankings;
      } else if (this.ranking === 'SWP') {
        return this.rankings.slice(0, 4);
      } else if (this.ranking === 'WM') {
        return this.rankings.slice(0, 3);
      }
      return [];
    },
    isAuthenticated() {
      return this.$store.getters['auth/isAuthenticated']
    },
    getFilteredTrainingData() {
      var filteredTraining = this.trainings

      if (this.inputMonth || this.inputYear || this.inputRanking) {

        filteredTraining = this.contentList

        //filter by month
        if (this.inputMonth) {
          let filterByMonth = []
          Object.keys(filteredTraining).filter(item => {
            let split = item.split("-")
            if (split[0] == this.inputMonth) {
              filterByMonth.push(item)
            }
          })

          let filtered = {}
          for (let x = 0; filterByMonth.length > x; x++) {
            filtered = {
              ...filtered,
              [filterByMonth[x]]: filteredTraining[filterByMonth[x]]
            }
          }

          filteredTraining = filtered
        }

        //filter by year
        if (this.inputYear) {
          let filterByYear = []
          Object.keys(filteredTraining).filter(item => {
            let split = item.split("-")
            if (split[1] == this.inputYear) {
              filterByYear.push(item)
            }
          })

          let filtered = {}
          for (let x = 0; filterByYear.length > x; x++) {
            filtered = {
              ...filtered,
              [filterByYear[x]]: filteredTraining[filterByYear[x]]
            }
          }

          filteredTraining = filtered
        }

        //filter by year
        if (this.inputRanking) {

          if (this.inputRanking !== 'all consultants') {
            // Filter by ranking
            let filterByRanking = [];
            for (let x = 0; Object.values(filteredTraining).length > x; x++) {
              Object.values(filteredTraining)[x].forEach(item => {
                if (item.data.targetUser === this.inputRanking) {
                  filterByRanking.push(item);
                }
              });
            }

            let filtered = this.groupBy(filterByRanking, 'monthYear');
            filteredTraining = filtered;
          }

        }

      }

      return filteredTraining
    }
  },
  created() {
    this.updateMobileView();
    window.addEventListener('resize', this.updateMobileView);
  }
}
</script>

<style scoped lang="scss">
@import '../styles/font.scss';

.registration-approved {
  display: flex;
  padding: 10px 10px 10px 5px;
  margin-bottom: 10px;
  gap: 10px;
  background-color: #F3F3F3;
  border-radius: 0px;
  display: flex;
  font-weight: 600;
  align-items: flex-start;
  width: 270px;
  height: 47px;
  white-space: nowrap;
}

.registration-approved-list {
  display: flex;
  padding: 0px 10px 20px 5px;
  margin-bottom: 10px;
  gap: 10px;
  background-color: #F3F3F3;
  border-radius: 0px;
  display: flex;
  font-weight: 600;
  align-items: flex-start;
  max-width: 130px;
  height: 47px;
  white-space: nowrap;
}

.registration-text {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.2px;
}

:deep() {

  .control .input,
  .control .textarea,
  .control .select,
  .control select {
    background: white !important;
    color: #363636;

    &:focus {
      border: none;
      outline: none;
      box-shadow: none;
    }
  }



  .searchbar-margin {
    margin-inline: 0em !important;
  }

  .searchbar-margin .control {
    padding: 0;
    // margin-left: 1rem;
  }
}



:deep() {
  .control select {
    padding-top: 0.25rem;
  }
}

a.course-details {
  color: unset !important;
}

.wrapper-contact {
  display: flex;
  justify-content: space-around;
}

.data-list-wrapper {
  margin: 2.5rem 0 1rem;

  .columns {
    margin-bottom: 2.5rem;

    .column.is-3 {
      width: 20%;
    }

    .column.is-2 {
      width: 21.66667%;
    }
  }

  .image-wrapper {
    max-width: 243px;
    max-height: 243px;
  }

  .join-now-btn {
    margin: 0;
  }
}

.join-now-btn {
  margin: 0rem 0;
  display: flex;
  justify-content: flex-end;
}

.desc-box {
  position: relative;
  box-sizing: border-box;
  height: 100%;
  max-width: 400px;
  // margin-top: 2.5rem;
  overflow: hidden;
}

.bottom-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

hr {
  padding: 4px !important;
  margin: 0 0 2.5rem;
}

.text-link {
  text-decoration-line: underline;
  color: #2F469C;
  font-weight: 600;
}

.month-tab {
  background-color: #2B2D47;
  color: #FFFFFF;
  width: 213px;
  height: 40px;
  padding: 10px 0 5px;
}

.ellipsis-title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 58px;
}

.ellipsis-title-list {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 58px;
}

.desc-textbox {
  min-height: 180px;
}

.grid-image {
  max-height: 340px;
  max-width: 340px;

  img {
    object-fit: cover;
  }
}

.grid-event-title {
  margin: 1.5rem 0;
}

.list-event-title {
  margin: 0.5rem 0 0.5rem;
}

.open-to-title {
  margin: 1.25rem 0 0;
}

.divider {
  display: flex;
  height: 1px;
  flex-direction: column;
  align-items: flex-start;
  color: #E0E0E0 !important;
  padding: 0rem !important;
  margin: 1rem;
}

.colour-text {
  text-decoration: underline;
}

@media(max-width: 768px) {
  .wrapper-contact {
    display: block;
    text-align: center;

    a {
      padding: 0.3rem 0;
      justify-content: center !important;
    }
  }
}

//mobile responsive
@media (min-width:1023px) {
  .column.is-2-desktop {
    width: 20%;
  }
}

@media (max-width: 500px) {

  .join-now-btn {
    margin: 1.5rem 0;
  }

  .column.is-6-mobile {
    width: 100%;
  }

  .grid-image {
    max-height: 100%;
    max-width: 100%;
  }

  .desc-box {
    max-width: 100%;
  }

  .ellipsis-title,
  .ellipsis-title-list .desc-textbox {
    min-height: unset;
  }
}

@media (min-width: 501px) and (max-width: 1023px) {
  .desc-textbox {
    min-height: 165px;
  }
}

@media (min-width: 1024px) and (max-width: 1215px) {
  .data-list-wrapper {
    img {
      min-height: auto !important;
    }

    .open-to-title {
      margin-top: 5px;
    }


  }

}

.desc-textbox {
  min-height: 171.5px;
}

.ellipsis-title {
  min-height: 46.5px;
}

.ellipsis-title-list {
  min-height: 30px;
}

@media (max-width: 1023px) {}

@media (min-width: 501px) and (max-width: 1215px) {}

@media (min-width: 1216px) and (max-width: 1407px) {
  .ellipsis-title {
    min-height: 52px;
  }

  .ellipsis-title-list {
    min-height: 30px;
  }

  .desc-textbox {
    min-height: 168.5px;
  }
}

@media (min-width: 1408px) and (max-width: 1660px) {
  .ellipsis-title {
    min-height: 60px;
  }

  .ellipsis-title-list {
    min-height: 30px;
  }
}

@media (min-width: 1661px) {

  .registration-approved-list {
    display: flex;
    padding: 0px 10px 20px 5px;
    margin-bottom: 10px;
    gap: 10px;
    background-color: #F3F3F3;
    border-radius: 0px;
    display: flex;
    font-weight: 600;
    align-items: flex-start;
    max-width: 300px;
    height: 47px;
    white-space: nowrap;
  }

  .ellipsis-title {
    min-height: 76px;
  }

  .ellipsis-title-list {
    min-height: 50px;
  }

  .desc-textbox {
    min-height: 200px;
  }
}</style>
